module.exports = __webpack_public_path__ + "static/media/no_profile2.0e011499.png";